export default "__VITE_ASSET__dbTLX701__"